// 临时人员接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/temporaryPerson/"

// 查询临时人员列表
export const postListPage = (pageNum, numPerPage, params) => {
  return http.post(CONTROLLER_NAME.concat("listPage"), {
    pageNum: pageNum,
    numPerPage: numPerPage,
    condition: params
  });
};

// 添加临时人员
export const postSubmitForm = infoForm => {
  return http.post(CONTROLLER_NAME.concat('addTemporaryPerson'), infoForm)
}

// 按月份查询
export const postMonth = (params) => {
  return http.post(CONTROLLER_NAME.concat("getTeamTemporaryPerson"), {
    condition: params
  });
};